import { Button } from "@ds/react";
import { ReactComponent as SuccessScreenIcon } from "assets/icons/success-screen-icon.svg";
import ResponsiveCard from "components/ResponsiveCard";
import Section from "components/Section";
import * as S from "./Sucesso.style";
import { useAppContext } from "contexts/AppContext";

const Sucesso = () => {
  const { clear } = useAppContext();

  return (
    <Section>
      <ResponsiveCard
        description={<SuccessScreenIcon />}
        fullContent
        maxContent
      >
        <S.ContainerStyleSuccessScreen>
          <S.StyleTitleSuccessScreen variant="headline-05">
            Parabéns! A compra do seu título de capitalização foi confirmada. A
            sorte está lançada!
          </S.StyleTitleSuccessScreen>

          <S.StyleDescriptionSuccessScreen variant="body-02-lg">
            Em alguns instantes, você vai receber um e-mail com a confirmação da
            sua compra.
          </S.StyleDescriptionSuccessScreen>

          <S.ContainerStyleSuccessScreenButton>
            <Button
              variant="secondary-md"
              onClick={() => {
                clear();
                window.location.href = "https://www.capvencedor.com.br";
              }}
            >
              Ir para a página inicial
            </Button>
          </S.ContainerStyleSuccessScreenButton>
        </S.ContainerStyleSuccessScreen>
      </ResponsiveCard>
    </Section>
  );
};

export default Sucesso;
